export const withPostLoginRedirect = (target: string): string => {
  if (typeof window === 'undefined' || !target.startsWith('/.auth/login/')) {
    return target;
  }

  const url = new URL(target, window.location.origin);
  if (!url.searchParams.has('post_login_redirect_uri')) {
    const returnPath = `${window.location.pathname}${window.location.search}${window.location.hash}` || '/';
    url.searchParams.set('post_login_redirect_uri', returnPath || '/');
  }

  return `${url.pathname}${url.search}${url.hash}`;
};

export const handleAuthRedirect = async (response: Response): Promise<boolean> => {
  if (![401, 403].includes(response.status)) {
    return false;
  }

  let payload: { redirectTo?: string; loginPath?: string } | undefined;
  try {
    payload = (await response.json()) as { redirectTo?: string; loginPath?: string };
  } catch {
    payload = undefined;
  }

  const target = payload?.loginPath || payload?.redirectTo;
  if (target && typeof window !== 'undefined') {
    window.location.assign(withPostLoginRedirect(target));
    return true;
  }

  return false;
};
